import React, { useState } from "react";
import { 
  FaChartLine, 
  FaUsers, 
  FaGlobe, 
  FaDownload, 
  FaClock, 
  FaFilter 
} from "react-icons/fa";

const ReportsContentPage = () => {
  const [activeStep, setActiveStep] = useState(1);

  const steps = [
    { id: 1, name: "Performance Overview", icon: <FaChartLine /> },
    { id: 2, name: "Affiliate Reports", icon: <FaUsers /> },
    { id: 3, name: "Traffic Analysis", icon: <FaGlobe /> },
    { id: 4, name: "Conversion Reports", icon: <FaDownload /> },
    { id: 5, name: "Custom Reports", icon: <FaFilter /> },
    { id: 6, name: "Scheduled Reports", icon: <FaClock /> },
  ];

  const renderContent = () => {
    switch (activeStep) {
      case 1:
        return <PerformanceOverview />;
      case 2:
        return <AffiliateReports />;
      case 3:
        return <TrafficAnalysis />;
      case 4:
        return <ConversionReports />;
      case 5:
        return <CustomReports />;
      case 6:
        return <ScheduledReports />;
      default:
        return <PerformanceOverview />;
    }
  };

  return (
    <>
   
      <div className="flex flex-col lg:flex-row min-h-full bg-gray-100">
    
        <div className="flex-1 p-2 md:p-4 lg:p-6 ">
          <div className="bg-white shadow-md rounded-lg p-4 lg:p-6 mb-10 lg:mb-0">
            <h2 className="text-2xl font-bold mb-4">Reports & Analytics</h2>
            <nav className="text-sm text-gray-500 mb-4">
              <span>Reports &gt; </span>
              <span className="text-gray-700">
                {steps.find((step) => step.id === activeStep)?.name}
              </span>
            </nav>

            <div className="flex flex-col lg:flex-row">
              {/* Steps Section */}
              <div className="w-full lg:w-1/4 mb-4 lg:mb-0 lg:pr-4">
                <div className="space-y-4">
                  {steps.map((step) => (
                    <div
                      key={step.id}
                      onClick={() => setActiveStep(step.id)}
                      className={`flex items-center space-x-2 cursor-pointer ${
                        activeStep === step.id ? "text-blue-600" : "text-gray-400"
                      }`}
                    >
                      <span
                        className={`w-6 h-6 flex items-center justify-center ${
                          activeStep === step.id
                            ? "bg-blue-600 text-white"
                            : "border"
                        } rounded-full`}
                      >
                        {step.icon}
                      </span>
                      <span>{step.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="w-full md:w-3/4">{renderContent()}</div>
            </div>
          </div>
        </div>
      </div>
   
    </>
  );
};

// Performance Overview Component
const PerformanceOverview = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Performance Overview</h3>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="border rounded-md p-4">
        <h4 className="text-sm font-medium text-gray-600">Total Revenue</h4>
        <p className="text-2xl font-bold text-green-600">$45,678.90</p>
        <span className="text-sm text-green-500">+12.5% vs last month</span>
      </div>
      <div className="border rounded-md p-4">
        <h4 className="text-sm font-medium text-gray-600">Conversions</h4>
        <p className="text-2xl font-bold text-blue-600">1,234</p>
        <span className="text-sm text-blue-500">+5.3% vs last month</span>
      </div>
      <div className="border rounded-md p-4">
        <h4 className="text-sm font-medium text-gray-600">Active Affiliates</h4>
        <p className="text-2xl font-bold text-purple-600">89</p>
        <span className="text-sm text-purple-500">+3 new this month</span>
      </div>
    </div>
    {/* Add charts or more detailed metrics here */}
  </div>
);

// Other report components
const AffiliateReports = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Affiliate Reports</h3>
    <div className="space-y-4">
      <div className="border rounded-md p-4">
        <h4 className="font-medium mb-2">Top Performing Affiliates</h4>
        {/* Add your affiliate reports content here */}
      </div>
    </div>
  </div>
);

const TrafficAnalysis = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Traffic Analysis</h3>
    <div className="space-y-4">
      <div className="border rounded-md p-4">
        <h4 className="font-medium mb-2">Traffic Sources</h4>
        {/* Add your traffic analysis content here */}
      </div>
    </div>
  </div>
);

const ConversionReports = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Conversion Reports</h3>
    <div className="space-y-4">
      <div className="border rounded-md p-4">
        <h4 className="font-medium mb-2">Conversion Metrics</h4>
        {/* Add your conversion reports content here */}
      </div>
    </div>
  </div>
);

const CustomReports = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Custom Reports</h3>
    <div className="space-y-4">
      <div className="border rounded-md p-4">
        <h4 className="font-medium mb-2">Build Custom Report</h4>
        {/* Add your custom reports builder here */}
      </div>
    </div>
  </div>
);

const ScheduledReports = () => (
  <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
    <h3 className="text-lg font-semibold mb-4">Scheduled Reports</h3>
    <div className="space-y-4">
      <div className="border rounded-md p-4">
        <h4 className="font-medium mb-2">Report Schedule</h4>
        {/* Add your scheduled reports content here */}
      </div>
    </div>
  </div>
);

export default ReportsContentPage; 